import React from 'react';
import {View} from 'react-native';

import {FilterButton} from '/component/base/SectionHeader/component';
import Text from '/component/base/Text';
import {SearchAndFilter} from '/constant/TestIDs';
import {SEARCH} from '/enum/filter.enum';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './Filter.style';

interface FilterProps {
  searchResultsSize: number;
}

export const Filter: React.FC<FilterProps> = ({searchResultsSize = 0}) => {
  const {tt} = useTranslation('screen.search');

  if (searchResultsSize === 0) {
    return null;
  }

  const resultText = tt(
    'result',
    `${searchResultsSize} ${searchResultsSize === 1 ? 'RESULT' : 'RESULTS'}`,
  );
  return (
    <View
      style={styles.container}
      accessible={false}
      // accessibilityLabel={getTextFromReactNode(resultText)}
    >
      <Text
        accessible={true}
        style={styles.result}
        variant="subheading"
        testID={SearchAndFilter.searchResultsCount}>
        {resultText}
      </Text>
      <FilterButton recordsName={SEARCH} />
    </View>
  );
};
